import React from 'react'

import {createLargeSvgIcon} from './utils'
import {css} from '../theme/css'

const root = css`
  && {
    filter: none;
  }
`

export default createLargeSvgIcon(
  <>
    <defs>
      <clipPath id="clip0">
        <rect width="256" height="256" rx="55.4667" />
      </clipPath>
    </defs>
    <g clip-path="url(#clip0)">
      <rect width="256" height="256" fill="#FF5226" />
      <path
        d="M111.176 17.3201L-41.79 256H23.6499L116.325 111.696L114.311 110.785L91.439 202.692L139.862 211.22L189.633 148.683L186.936 147.334L170.123 218.383L280.633 197.328L259 161.723L216.077 171.537L220.56 176.703L238.265 102.502L197.023 74.9192L142.996 142.851L145.693 144.199L167.882 55.1999L111.176 17.3201Z"
        fill="#FFDD00"
      />
    </g>
  </>,
  'Market2',
  {className: root, viewBox: '0 0 256 256'},
)
